import React, { useState, useRef, useEffect } from "react";
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import { createGeoInput, DefaultGeoInput } from 'react-geoinput';
import filesService from '../../services/file.service';
import { toastOptions } from '../shared/selectStyle';
import './style.css';
import Gallery from 'react-grid-gallery';

const AddressInput = createGeoInput(DefaultGeoInput);
const Upload = () => {
    const { t, i18n } = useTranslation();
    const history = useHistory()
    const refFileInput = useRef(null);
    const [addresPlaceholder, setAddresPlaceholder] = useState('');
    const [error, setError] = useState(false);
    const [infoData, setInfoData] = useState({
        description: ""

    });

    const [images, setImages] = useState([]);
    const [currentImage, setCurrentImage] = useState([]);
    // const [url, setUrl] = useState(null)
    const [imageBeforeUpload, setImageBeforeUpload] = useState('');
    const [address, setAddress] = useState('');
    const [geoDestination, setGeoDestination] = useState('');

    useEffect(() => {
        if (i18n.language === "en") {
            setAddresPlaceholder('Address')
        } else {
            setAddresPlaceholder('Adresa')
        }
    }, [i18n.language]);

    const onAddressChange = value => {
        setError(false);
        setAddress(value)
    }
    const onGeoDestinationChange = value => {
        setError(false);
        setGeoDestination(value)
    }


    const handleChangeFile = (e) => {
        setError(false);

        let file = e.target.files[0];
        const imageData = {
          src: URL.createObjectURL(file),
          thumbnail: URL.createObjectURL(file),
          thumbnailWidth: 320,
          thumbnailHeight: 174,
          file
        }
        setImages([...images, imageData]);
        if (file) {
            setImageBeforeUpload(URL.createObjectURL(file));
        } else {
            setImageBeforeUpload('')
        }
    }

    const handleChange = (e) => {
        setError(false);
        e.preventDefault();
        setInfoData({
            ...infoData,
            [e.target.name]: e.target.value
        });

    }

    const handleUpload = async (event) => {
        setGeoDestination('');
        if (validateForm()) {
            await getUploadLink();
        } else {
            setError(true);
        }

    }

    const getUploadLink = async () => {

        const file = images[0].file
        let fileData = file.name;
        let dotIndex = fileData.lastIndexOf(".");
        let fileName = fileData.slice(0, dotIndex);
        let fileExt = fileData.slice(dotIndex + 1);
        let data = {
            file: fileName,
            ext: fileExt,
            address: address,
            description: infoData.description,
            images: images.map(({ file }) => file.type)
        }
        if (validateForm()) {
            const response = await filesService.saveAndGetUploadLinks(data);
            if (response) {
                const { urls = [] } = response
                for (let i=0; i < urls.length; i++) {
                    await filesService.uploadImageAmazon(urls[i], images[i].file);
                }
                history.push("/dashboard/folder");
                toast.success("Image uploaded successfully to Amazon !", toastOptions);

            } else {
                toast.error("Invalid address!", toastOptions);
            }
        } else {
            toast.error("Invalid data!", toastOptions);
        }
    }
    const validateForm = () => {
        return infoData.description && address && images.length > 0;
    }
    const triggerUploadBtn = () => {
        refFileInput.current.click()
    }

    const onCurrentImageChange =(index) => {
        setCurrentImage(index);
    }

    const deleteImage = () => {
        images.splice(currentImage, 1)
        setImages(images)
    }
console.log('images', images)
    return (<div className="dashboard-view space-around">
        <div className="upload-wrapper">
            <div className="upload-container" >
                <div onClick={triggerUploadBtn} className="upload-input-box">
                    <p>{t('upload.title')}: </p>
                    <img  src="/assets/images/imageGrey.svg" alt="file" />
                    <input ref={refFileInput} className='upload-input' type="file" onChange={handleChangeFile} />
                </div>
                <div className="form-group custom-input geo-hint-wrapper">
                    <img  src="/assets/images/locationSmall.svg" alt="location" />
                    <AddressInput
                        addressInput={{
                            onChange: onAddressChange,
                            value: address,
                            placeholder: addresPlaceholder
                        }}
                        geoDestinationInput={{
                            onChange: onGeoDestinationChange,
                            value: geoDestination,
                        }}
                        className="geo-hint-input"
                    />
                </div>
                <div className="form-group custom-input">
                    <img  src="/assets/images/pen.svg" alt="description" />
                    <input id='description' className="form-control" type="text" name="description" value={infoData.description} onChange={handleChange} placeholder={t('placeholder.description')} />
                </div>
                {error ? <div className="message-alert mb-4"><p>{t('requiredFields.msg')}</p></div> : null}
                <button className="btn btn-blue" onClick={handleUpload}>Upload </button>
            </div>
            <div className="upload-img-preview">
                {imageBeforeUpload ? <div>
                    <Gallery
                      images={images}
                      enableLightbox={true}
                      enableImageSelection={false}
                      currentImageWillChange={onCurrentImageChange}
                      customControls={[
                          <i className="fa fa-trash" aria-hidden="true" onClick={deleteImage} ></i>
                      ]}
                    />
                </div> : null}
            </div>
        </div>
    </div>);
}

export default Upload;




// WEBPACK FOOTER //
// ./src/components/uploadComponent/upload.js